/**
 * feature-config flag names owned by optimize
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const OPTIMIZE_FLAG_NAMES = {
  INTELLIMIZE_INTEGRATION: 'ff-imize-integration',
  OPTIMIZATION_PRIMARY_METRICS: 'optimization-primary-goals-op-1083',
  OPTIMIZATION_CLICK_GOALS: 'ff-op-946-optimization-click-goals',
  OPTIMIZATION_UPSELL: 'ff-optimization-upsell',
  OPTIMIZATION_DEMO_MODE: 'ff-op-1813-optimize-demo-mode',
  OPTIMIZATION_LIMIT_AUDIENCES: 'ff-oo-905-optimize-limit-audience',
  OPTIMIZATION_PERSONALIZE_MANAGE_AUDIENCES:
    'ff-op-1246-personalize-optimize-manage-audiences',
  OPTIMIZATION_LIMITED_MODE_CONDITION: 'ff_op-1717_limited_mode_condition',
  OPTIMIZATION_INTEGRATIONS_GA4_SEGMENT_MIXPANEL:
    'ff-op-1638-optimize-integrations-ga4-segment-mixpanel',
  OPTIMIZATION_SHOW_CUSTOM_AUDIENCE_ATTRIBUTES:
    'ff-op-1735-show-custom-audience-attributes',
  OPTIMIZATION_REDIRECT_TESTS: 'ff-op-1532-redirect-tests',
  OPTIMIZATION_AI_ASSISTANT: 'ff-op-1535-ai-optimize-playbooks',
  OPTIMIZATION_AI_ASSISTANT_COMPONENTS:
    'ff-op-1979-ai-assistant-variations-components',
  OPTIMIZATION_LOCALE_AUDIENCE: 'ff-op-1740-locale-audience',
  OPTIMIZATION_DELETE_OPTIMIZATION_WRAPPERS:
    'ff-op-724-delete-optimization-wrappers',
  OPTIMIZATION_FETCH_STANDALONE_SITES: 'ff-op-2016-fetch-standalone-sites',
  OPTIMIZATION_RETURN_STANDALONE_FIXTURE:
    'ff-op-2016-return-standalone-fixture',
  OPTIMIZATION_AI_TRAFFIC_SOURCE: 'ff-op-2584-ai-traffic-source',
  OPTIMIZATION_AB_RELAUNCHING: 'ff-op-2270-ab-relaunching',
  OPTIMIZATION_GRADUATION_FLOWS_RELEASE_5: 'op-2313-graduation-flows-release-5',
  OPTIMIZATION_GRADUATION_FLOWS_APPLY_CHANGES:
    'ff-op-1534-graduation-flows-apply-changes',
  OPTIMIZATION_NEW_REPORT_TEST: 'ff-op-2884-new-report-test',
  OPTIMIZATION_NEW_REPORT_PERSONALIZE: 'ff-op-2884-new-report-personalize',
  OPTIMIZATION_NEW_REPORT_AI_OPTIMIZE: 'ff-op-2884-new-report-ai-optimize',
  OPTIMIZATION_AI_ASSISTANT_CUSTOM_PROMPTS: 'ff-op-2857-playbook-prompt',
  OPTIMIZATION_AI_SUGGESTIONS_SHARED_CODE:
    'ff-op-3365-ai-suggestions-shared-code',
  OPTIMIZATION_PAGE_VIEW_CREATE_MODAL: 'ff-op-2793-page-view-create-modal',
  DATA_OUT: 'ff-prequel-op-3210-data-out',
  CUSTOM_GOALS: 'ff-cri-1-custom-goals',
  NON_HOSTED_SITE_FALLBACK_ADMIN: 'ff-convert-op-3303-non-hosted-sites-admin',
  OPTIMIZATION_ANTI_FLICKER_TIMEOUT: 'ff-op-3462-optimize-antiflicker-timeout',
  OPTIMIZATION_SKIP_EMPTY_PAGE_ANTI_FLICKER:
    'ff-cvin-369-skip-optimize-anti-flicker',
  AUDIENCE_AI_NAMING: 'ff-op-3481-audience-ai-naming',
  OPTIMIZE_PUBLIC_NON_HOSTED_ENABLED:
    'ff-opt-3614-optimize-public-non-hosted-enabled',
  OPTIMIZE_PUBLIC_API_ENABLED: 'ff-opt-3614-optimize-public-api-enabled',
  OPTIMIZE_PUBLIC_PER_TOKEN_CONCURRENCY_LIMIT_ENFORCE_ENABLED:
    'ff-opt-3862-optimize-public-per-token-concurrency-limit-enforce-enabled',
  ADMIN_UI_MERGE_INTERVALS:
    'ff-shopify-revenue-tracking-cvin-341-admin-ui-merge-intervals',
};

export const OPTIMIZE_DYNAMIC_CONFIG_NAMES = {
  OPTIMIZE_PUBLIC_CONCURRENCY_LIMIT:
    'dc-opt-3862-optimize-public-concurrency-limit',
} as const;
